import {
  lastAssistantMessageIsCompleteWithApprovalResponses,
  lastAssistantMessageIsCompleteWithToolCalls,
  type UIMessage,
} from 'ai';

/**
 * Auto-send condition covering both HITL lanes: a resolved client tool call (human tool resolving
 * via `addResult`) OR a completed approval response (`respondToApproval` on a server-side gate).
 * The stock tool-calls predicate alone would NEVER auto-send approval responses.
 */
export function lastAssistantMessageIsCompleteWithToolCallsOrApprovalResponses({
  messages,
}: {
  messages: UIMessage[];
}): boolean {
  return (
    lastAssistantMessageIsCompleteWithToolCalls({ messages }) ||
    lastAssistantMessageIsCompleteWithApprovalResponses({ messages })
  );
}
